/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from "styled-components";
import Colors from 'constants/Colors';
import { FontWeight, FiraSansBold } from 'components/Text';
import { Breakpoints } from "constants/Breakpoints";


export const Text = styled.text`
  color: ${Colors.GRAY[6]};
  font-weight: ${FontWeight.SemiBold};
  text-transform: uppercase;
  font-size: 16px;
  cursor: pointer;
`;


export const Title = styled.label`
  font-size: 16px;
  color: ${Colors.GRAY[6]};
  ${FiraSansBold}
  `;
  
export const ButtonContent = styled.div`
  display:flex;
  flex-direction:auto;
  background-color:#FFF;  
  justify-content: space-evenly;
  
  @media (max-width: ${Breakpoints.lg}) {  
    flex-wrap: wrap;
    padding-right: 30px;
    width: 100%;
  }
`;











